import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Slide from '@mui/material/Slide';
import AddHomeWorkIcon from '@mui/icons-material/AddHomeWork';
import HorizontalLinearStepper from './linearStepper';



const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function AlertDialogSlide({getProperties}) {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <button className='px-5 py-2 bg-austel-green hover:bg-[#0d964d] hover:font-semibold flex items-center gap-1 !rounded-full text-white transition-all ease-in duration-500' onClick={handleClickOpen}> <AddHomeWorkIcon className='text-white' /> <p className='ml-2 flex font-semibold text-[14px] md:text-[16px] items-center py-auto mt-2'>Add Property</p>
            </button>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <HorizontalLinearStepper getProperties={getProperties} open={open} setOpen={setOpen} />
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </div>
    );
}



